export function trackAffiliateClick({ tool, slug }) {
  if (!window.gtag) return;

  window.gtag("event", "affiliate_click", {
    event_category: "affiliate",
    event_label: tool,
    page_path: `/blog/${slug}`,
  });
}